import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import './formStatus.scss';
import Label from '../../atoms/label/label';
import swal from 'sweetalert';
import { httpPost} from '../../../store/externalCalls/httpCalls';
import { isArray } from 'lodash';
import { epochToDateTime } from '../../../utils/dateUtils';


const FormCellDate = (props) => {
  const {
    id,value, mode
  } = props;
  const [formattedValue, setFormattedValue] = useState(value);

  useEffect(()=>{
    // console.log('cellDate',id,value,mode);
    let v;
    if(mode=="date"){
      // console.log('cellDate',id,value,mode);
      v=epochToDateTime(value,"date");

    
    }else if(mode=="time"){
      v=epochToDateTime(value,"time");
    }else if(mode=="datetime"){
      v=epochToDateTime(value,mode);
    }
    setFormattedValue(v);
  },[value]);
  
  return (
  <div className="form-cell-date">
    {formattedValue}
  </div>
  );
};

FormCellDate.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string,
  mode: PropTypes.string,
};

FormCellDate.defaultProps = {
  value: '',
  id: 'NoId',
  mode: '',
};

export default FormCellDate;
